/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Button,
  Spinner
} from '@chakra-ui/react'
import ResponsivePagination from 'react-responsive-pagination'

const TableHeader = ({ columns, actionsTitle = '' }) => (
  <Thead>
    <Tr>
      { columns.map(column => (
        <Th key={column.id}>{column.title}</Th>
      ))}
      <Th>{ actionsTitle }</Th>
    </Tr>
  </Thead>
)

const TableBody = ({
  columns,
  items,
  editItem,
  deleteItem
}) => (
  <Tbody>
    {
      items?.map(item => (
        <Tr key={item.id}>
          {columns.map(column => (
            <Td key={column.id}>{ item[column.id] }</Td>
          ))}
          <Td>
            { editItem &&
              <Button onClick={() => editItem(item.id)} mr={2}>Edit</Button>
            }
            { deleteItem &&
              <Button onClick={() => deleteItem(item.id)} colorScheme="red">Delete</Button>
            }
          </Td>
        </Tr>
      ))}
  </Tbody>
)

const DefaultCrudTable = ({
  children,
  onPageChange,
  page,
  totalPages,
  loading
}) => {
  if (loading) return <div className="text-center"><Spinner size='lg' /></div>

  return (
    <>
      <TableContainer className="mb-6">
        <Table
          variant="simple"
          className="whitespace-normal"
        >
          { children }
        </Table>
      </TableContainer>
      { !!totalPages &&
        <ResponsivePagination
          current={+page}
          total={+totalPages}
          linkHref="omit"
          onPageChange={onPageChange}
        />
      }
    </>
  )
}

DefaultCrudTable.Header = TableHeader
DefaultCrudTable.Body = TableBody

export default DefaultCrudTable
